export const SHORE_USER_MIN_PASS_LENGTH_FIELD = 'Office.MinimumLength';
export const SHORE_USER_MAX_PASS_LENGTH_FIELD = 'Office.MaximumLength';
export const SHORE_USER_SMALL_LETTER_FIELD = 'Office.RequireLowercase';
export const SHORE_USER_CAPITAL_LETTER_FIELD = 'Office.RequireUppercase';
export const SHORE_USER_DIGIT_FIELD = 'Office.RequireDigit';
export const SHORE_USER_SPECIAL_CHAR_FIELD = 'Office.RequireSpecialCharacter';
export const SHORE_USER_DIFFERENT_PASS_FIELD = 'Office.MustDifferFromOldPassword';
export const SHORE_USER_PASS_EXPIRY_ENABLED_FIELD = 'Office.PasswordExpiryEnabled';
export const SHORE_USER_SESSION_EXPIRY_ENABLED_FIELD = 'Office.SessionExpiryEnabled';
export const SHORE_USER_FORCE_PASS_CHANGE_FIELD = 'Office.PasswordExpiry';
export const SHORE_USER_SESSION_INACTIVITY_TIMEOUT_FIELD = 'Office.SessionExpiry';

export const CREW_USER_MIN_PASS_LENGTH_FIELD = 'Crew.MinimumLength';
export const CREW_USER_MAX_PASS_LENGTH_FIELD = 'Crew.MaximumLength';
export const CREW_USER_SMALL_LETTER_FIELD = 'Crew.RequireLowercase';
export const CREW_USER_CAPITAL_LETTER_FIELD = 'Crew.RequireUppercase';
export const CREW_USER_DIGIT_FIELD = 'Crew.RequireDigit';
export const CREW_USER_SPECIAL_CHAR_FIELD = 'Crew.RequireSpecialCharacter';
export const CREW_USER_DIFFERENT_PASS_FIELD = 'Crew.MustDifferFromOldPassword';
export const CREW_USER_PASS_EXPIRY_ENABLED_FIELD = 'Crew.PasswordExpiryEnabled';
export const CREW_USER_SESSION_EXPIRY_ENABLED_FIELD = 'Crew.SessionExpiryEnabled';
export const CREW_USER_FORCE_PASS_CHANGE_FIELD = 'Crew.PasswordExpiry';
export const CREW_USER_SESSION_INACTIVITY_TIMEOUT_FIELD = 'Crew.SessionExpiry';

export const PW_SESSION_STEP_TITLE = 'pwSession';
export const PASSWORD_POLICY_ENTITY_TYPE = 'PasswordPolicy';

export const CREW_GROUP = 'Crew';
export const SHORE_GROUP = 'Office';

export const SHORE_USERS_PASSWORD_POLICY_CONFIG = {
    group: SHORE_GROUP,
    entityType: PASSWORD_POLICY_ENTITY_TYPE,
    fields: {
        minPassLength: SHORE_USER_MIN_PASS_LENGTH_FIELD,
        maxPassLength: SHORE_USER_MAX_PASS_LENGTH_FIELD,
        smallLetter: SHORE_USER_SMALL_LETTER_FIELD,
        capitalLetter: SHORE_USER_CAPITAL_LETTER_FIELD,
        digit: SHORE_USER_DIGIT_FIELD,
        specialChar: SHORE_USER_SPECIAL_CHAR_FIELD,
        differentPass: SHORE_USER_DIFFERENT_PASS_FIELD,
        passExpiryEnabled: SHORE_USER_PASS_EXPIRY_ENABLED_FIELD,
        forcePassChange: SHORE_USER_FORCE_PASS_CHANGE_FIELD,
        sessionExpiryEnabled: SHORE_USER_SESSION_EXPIRY_ENABLED_FIELD,
        sessionInactivityTimeout: SHORE_USER_SESSION_INACTIVITY_TIMEOUT_FIELD,
    },
} as const;

export const CREW_USERS_PASSWORD_POLICY_CONFIG = {
    group: CREW_GROUP,
    entityType: PASSWORD_POLICY_ENTITY_TYPE,
    fields: {
        minPassLength: CREW_USER_MIN_PASS_LENGTH_FIELD,
        maxPassLength: CREW_USER_MAX_PASS_LENGTH_FIELD,
        smallLetter: CREW_USER_SMALL_LETTER_FIELD,
        capitalLetter: CREW_USER_CAPITAL_LETTER_FIELD,
        digit: CREW_USER_DIGIT_FIELD,
        specialChar: CREW_USER_SPECIAL_CHAR_FIELD,
        differentPass: CREW_USER_DIFFERENT_PASS_FIELD,
        passExpiryEnabled: CREW_USER_PASS_EXPIRY_ENABLED_FIELD,
        forcePassChange: CREW_USER_FORCE_PASS_CHANGE_FIELD,
        sessionExpiryEnabled: CREW_USER_SESSION_EXPIRY_ENABLED_FIELD,
        sessionInactivityTimeout: CREW_USER_SESSION_INACTIVITY_TIMEOUT_FIELD,
    },
} as const;
